import Layout from "../../../../src/components/Octopath/layout";
import React from 'react';
export default {
  Layout,
  React
};